import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { BaseModalModule } from '../../base-modal.module';
import { EOPMilestoneModalComponent } from './eop-milestone-modal.component';
import { NvDesignLibraryModule } from 'Src/nvps-libraries/design/nv-design-library.module';

@NgModule({
  declarations: [EOPMilestoneModalComponent],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDialogModule,
    BaseModalModule,
    NvDesignLibraryModule,
  ],
  exports: [EOPMilestoneModalComponent],
  entryComponents: [EOPMilestoneModalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EOPMilestoneModalModule {}
